export default "__VITE_ASSET__ljAGzD5B__"